var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[_c('v-col',{attrs:{"cols":"12","md":"12"}},[_c('table',{staticStyle:{"width":"100%"}},[_c('tr',[_c('th',{staticStyle:{"width":"30%"}},[_vm._v("Dates:")]),_c('td',[_vm._v(_vm._s(this.item.item.vacationDates.join(", ")))])])])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }